import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "StarOn"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M284 868L512 748l228 120q4 0.992 7.008-0.992t2.016-6.016l-43.008-254.016 184-180q3.008-3.008 2.016-6.496t-4.992-4.512l-255.008-36.992-114.016-231.008q-2.016-4-6.016-4t-6.016 4l-114.016 231.008-255.008 36.992q-4 0.992-4.992 4.512t2.016 6.496l184 180-44 254.016q0 4 3.008 6.016t7.008 0.992z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var starOn = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\star-on.vue"]]);

export { starOn as default };
